import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import {LoginComponent} from '../login/login.component';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../login-service';
import { ToastrModule } from 'ngx-toastr';
@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  providers:[ToastrModule]
  // styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {
  usersList:any;
  displayerror:boolean=true;
  registerForm: FormGroup;
  userTypeName:string;
  submitted = false;
  errorMessage:any;
  userID:any;
  constructor(private formBuilder: FormBuilder, private router:Router,private loginS :LoginService,private activateRoute:ActivatedRoute) { 
   this.userTypeName='1';
  }

  ngOnInit(): void {
    this.GetUsers();
    this.registerForm = this.formBuilder.group({
      
      email: ['', [Validators.required, Validators.email]]
      
  },
  );
  }
  GetUsers(){
    this.loginS.GetUsers(this.userTypeName).subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.usersList = data;
      });
  }
  get f() { return this.registerForm.controls; }

  onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.registerForm.invalid) {
          return;
      }
      else{
    
     let validateEmailAddress=this.usersList.filter(x=>x.email.toLowerCase().toString()===this.registerForm.value.email.toLowerCase().toString());
     if(validateEmailAddress.length>0){
      this.errorMessage="";
     this.router.navigate(['/reset', validateEmailAddress[0].id,validateEmailAddress[0].email]);
     
     }
     else{
     this.errorMessage="Email Doest not exist";
     }
      // alert('Email validated')
      
      }
  }

}

